import React from 'react';
import { Skeleton, SxProps, Theme } from '@mui/material';

interface CircleBoneProps {
    /** Animation */
    animation?: 'pulse' | 'wave' | false;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const CircleBone: React.FunctionComponent<CircleBoneProps> = function ({
    animation = 'pulse',
    sx = {},
}) {
    return (
        <Skeleton
            variant="circular"
            animation={animation}
            role="progressbar"
            sx={sx}
        />
    );
};
